export default "__VITE_ASSET__CNGUsl$2__"